import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
  Typography,
  Box,
  useMediaQuery
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Receipt as TransactionsIcon,
  Assessment as ReportsIcon,
  People as UsersIcon,
  Settings as SettingsIcon
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../assets/logo.png'; // Add this import

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const isMobile = useMediaQuery('(max-width: 768px)');

  if (isMobile) {
    return null; // Only show sidebar on desktop
  }

  // Check permissions for each navigation item
  const canAccessUsers = user?.permissions?.users?.includes('read');
  const canAccessSettings = user?.permissions?.settings?.includes('read');

  const navigationItems = [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
    { label: 'Transactions', icon: <TransactionsIcon />, path: '/transactions' },
    { label: 'Reports', icon: <ReportsIcon />, path: '/reports' },
    { label: 'User Management', icon: <UsersIcon />, path: '/users', show: canAccessUsers },
    { label: 'Settings', icon: <SettingsIcon />, path: '/settings', show: canAccessSettings },
  ].filter(item => item.show !== false);

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
          backgroundColor: '#f5f5f5',
          borderRight: '1px solid #e0e0e0'
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <img 
            src={logo} // Use the imported logo variable
            alt="Artha Bhaskar" 
            style={{ height: '32px', width: 'auto' }}
          />
          <Typography variant="h6" noWrap component="div" style={{ color: '#1976d2' }}>
            Artha Bhaskar
          </Typography>
        </Box>
      </Box>
      
      <Divider />
      
      <List sx={{ mt: 1 }}>
        {navigationItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => navigate(item.path)}
              sx={{
                '&.Mui-selected': {
                  backgroundColor: '#e3f2fd',
                  borderRight: '3px solid #1976d2',
                },
                '&.Mui-selected:hover': {
                  backgroundColor: '#e3f2fd',
                },
              }}
            >
              <ListItemIcon sx={{ color: location.pathname === item.path ? '#1976d2' : 'inherit' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText 
                primary={item.label} 
                primaryTypographyProps={{
                  fontWeight: location.pathname === item.path ? 'bold' : 'normal'
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
}

export default Sidebar;